<template>
  <modal
    name="pushkin-card-payment"
    width="100%"
    height="auto"
    :scrollable="true"
    :clickToClose="false"
    @opened="openDialogHandler"
  >
    <template
      v-if="
        paymentState === pushkinCardPaymentStates.Payment ||
        paymentState === pushkinCardPaymentStates.Paid ||
        paymentState === pushkinCardPaymentStates.Succeed
      "
    >
      <h1 class="modal-label">Ожидание оплаты заказа</h1>

      <div class="card-payment-content">
        <div>
          <p>Проверка валидации билета.</p>
          <p>
            Пожалуйста, подождите пока мы проверяем билет. После успешной оплаты
            страница автоматически обновится.
          </p>
        </div>
      </div>
      <button
        v-if="paymentState === pushkinCardPaymentStates.Payment"
        @click="openPaymentUrlInNewTab"
      >
        <p>Перейти к оплате</p>
      </button>
    </template>
    <template v-if="paymentState === pushkinCardPaymentStates.Canceled">
      <h1 class="modal-label">Произошла ошибка</h1>
      <div class="card-payment-content">
        <div>
          <p>
            К сожалению, сервис проверки отклонил покупку по Пушкинской карте.
            Заказ был отменен.
          </p>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PushkinCardPayment',

  props: ['url', 'paymentId'],

  watch: {
    orderInfo(val) {
      if (val) {
        switch (val.Status) {
          case 'Created':
          case 'Payment':
          case 'Reserved':
            this.paymentState = this.pushkinCardPaymentStates.Payment;
            break;
          case 'Paid':
            this.paymentState = this.pushkinCardPaymentStates.Paid;
            break;
          case 'Succeed':
            this.paymentState = this.pushkinCardPaymentStates.Succeed;
            this.$router.push({ name: 'success' });
            break;
          default:
            this.paymentState = this.pushkinCardPaymentStates.Canceled;
        }
      }
    },
  },

  computed: {
    ...mapState(['orderInfo']),
  },
  methods: {
    hide() {
      this.$modal.hide('pushkin-card-payment');
    },
    openPaymentUrlInNewTab() {
      window.open(this.url, '_blank');
    },

    openDialogHandler() {
      this.$store.dispatch('checkPushkinPaymentAndSetOrderInfo', {
        paymentId: this.paymentId,
      });
    },
  },
  data() {
    const pushkinCardPaymentStates = {
      Payment: 'Payment',
      Paid: 'Paid',
      Succeed: 'Succeed',
      Canceled: 'Canceled',
    };

    return {
      paymentState: pushkinCardPaymentStates.Payment,
      pushkinCardPaymentStates,
    };
  },
};
</script>

<style lang="scss">
.card-payment-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.v--modal {
  background-color: #000000d5 !important;
  display: block;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &-overlay[data-modal='card-payment'] {
    overflow-x: hidden;
    .b-text {
      margin-bottom: 15px;
      p {
        margin-bottom: 8px;
      }
      strong {
        font-weight: bold;
      }
      a {
        color: #0d76ff;
      }
    }
    .modal-button {
      padding: 0 30px;
    }
    .v--modal-box {
      padding: 20px 30px;
    }
    .pz-close-btn {
      top: 0;
      right: -10px;
    }
    .modal-label {
      padding: 0 70px 10px;
      margin-top: 20px;
    }
  }
}

.modal {
  &-form {
    width: 335px;
  }
  &-label {
    display: block;
    padding: 0 10px 10px;
    font-size: 24px;
    margin-bottom: 20px;
    line-height: 24px;
    letter-spacing: 0.024em;
    color: #fff;
    text-align: center;
  }
  &-input {
    margin-bottom: 15px;
    input {
      border: none;
      outline: none;
      background-color: #fff;
      border-radius: 10px;
      padding: 16px 25px;
      font-size: 18px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
    }
  }
  &-buttons {
    display: flex;
    flex-wrap: nowrap;
  }
  &-button {
    margin: 0 15px 0 0;
    height: 56px;
    border-radius: 10px;
    border: 1px solid #fff;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #fff;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 10px;
    text-align: center;
    justify-content: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    flex: 1;
    &:last-of-type {
      margin-right: 0;
    }
    &-primary {
      background-color: #0d76ff;
      border-color: transparent;
    }
  }
}

@media screen and (max-width: 768px) {
  .v--modal {
    &-overlay[data-modal='card-payment'] {
      .pz-close-btn {
        top: 10px;
        right: 10px;
      }
      .modal-label {
        margin-top: 30px;
      }
    }
  }
}
</style>
